module.exports = __webpack_public_path__ + "static/media/flowpaper_logo@2x.c0fad2df.png";